module.exports = {
	"id": "IM",
	"name": "Isle of Man",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.00663,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": 0.01326,
			"42": null,
			"43": 0.03315,
			"44": null,
			"45": 0.00663,
			"46": null,
			"47": 0.05304,
			"48": 0.04641,
			"49": 1.88955,
			"50": 0.31824,
			"51": 0.1989,
			"52": 0.68289,
			"53": 29.73555,
			"54": 3.66639,
			"55": 0.0663,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.15912,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.02652,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.03978,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.03978,
			"39": 0.14586,
			"40": null,
			"41": null,
			"42": 0.01989,
			"43": 0.01326,
			"44": 0.01326,
			"45": 0.02652,
			"46": 0.00663,
			"47": 0.25857,
			"48": 0.25194,
			"49": 5.17803,
			"50": 0.01989,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00663,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.00663,
			"36": null,
			"37": 0.03315,
			"38": null,
			"39": null,
			"40": 0.17901,
			"41": 0.00663,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.02652,
			"5": 0.08619,
			"6": null,
			"7": 0.01989,
			"8": 0.08619,
			"9": 0.8619,
			"10": 2.18127,
			"3.1": null,
			"3.2": null,
			"5.1": 0.16575,
			"6.1": 0.0663,
			"7.1": 0.22542,
			"9.1": 1.40556
		},
		"ios_saf": {
			"8": 0,
			"10": 12.4470094172,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.335432501041,
			"8.1-8.4": 0.619697332431,
			"9.0-9.2": 0.295635424646,
			"9.3": 4.51033532473
		},
		"android": {
			"3": 0,
			"4": 0.011094005168,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00138675064599,
			"4.1": 0.0400176614987,
			"4.2-4.3": 0.100044153747,
			"4.4": 0.229408178295,
			"4.4.3-4.4.4": 0.231389250646
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.33813,
			"9": 0.76245,
			"10": 0.31161,
			"11": 10.43562,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00139442468663,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000038734019073
		},
		"edge": {
			"12": 0.13923,
			"13": 0.76908,
			"14": 4.5747
		},
		"ie_mob": {
			"10": 0.158152676056,
			"11": 0.643907323944
		},
		"bb": {
			"7": 0.0210625,
			"10": null
		},
		"samsung": {
			"0": 4.10129
		},
		"and_uc": {
			"0": 0.05392
		},
		"op_mini": {
			"0": 0.0187868412943
		},
		"and_chr": {
			"0": 9.63076
		},
		"and_ff": {
			"0": 0.01011
		}
	},
	"total": 99.0647225
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IM.json
 ** module id = 550
 ** module chunks = 0
 **/